import { useEffect, useRef, useState } from 'react';
import { ChargeStatus, RobotDetailData, RobotListData } from "../types/Robot"
import { TaskListData, TaskRecord, TaskStatus, TaskType } from '../types/Task';
import { Alert, Backdrop, Box, Card, CircularProgress, Modal, Stack } from '@mui/material';
import { getRobotStatus, listRobots, listRobotsInfos } from '../api/robot';
import { map } from '../types/Map';
import { useQuery } from 'react-query';
import { getTask, listCurrentLocationTask } from '../api/task';
import { Notification } from "../components/Notification";
import { CompartmentJob } from '../components/CompartmentCallJob';
import { RobotCardRobotConfig } from '../components/RobotCardRobotConfig';
import { QueuedDeliverySimulation } from '../components/QueuedDeliverySimulation';
import { ProgressDeliveryTimeoutIndicationSimulation } from '../components/ProgressDeliveryTimeoutIndicatorSimulation';
import { TaskCollectionType, TaskRecordCollectionData, TaskRecordCollectionSendData } from '../types/TaskCollection';
import { createTaskCollection, globalLatestLocationTaskCollections, receipientOfTaskCollection } from '../api/taskCollection';
import { PinCode } from '../components/PinCode';
import { NotificationPinCode } from '../components/NotificationPinCode';
import { NotificationYesNo } from '../components/NotificationYesNo';


export const OverviewUpdated = (props: {
    currentLocationID: number,
    currentLocationName: string,
}) => {
    const {currentLocationID, currentLocationName} = props;

    const [robotsList, setRobotsList] = useState<RobotListData[]>([]);
    const [robotsDetail, setRobotsDetail] = useState<RobotDetailData[]>([]);
    const [tasks, setTasks] = useState<TaskListData[]>([]);
    const [status, setStatus] = useState<number>(0);
    const [currentTaskRecord, setCurrentTaskRecord] = useState<TaskRecord | undefined>(undefined);
    const [selectedRobot, setSelectedRobot] = useState<RobotDetailData | undefined>(undefined);
    const [taskRobot, setTaskRobot] = useState<RobotDetailData | undefined>(undefined);
    const [currentTaskRecordCollection, setCurrentTaskRecordCollection] = useState<TaskRecordCollectionData | undefined>(undefined)
    const [recipientOfTaskRecordCollection, setRecipientOfTaskRecordCollection] = useState<TaskRecordCollectionData | undefined>(undefined)
    const [latestGlobalTaskRecordCollection, setLatestGobalTaskRecordColleection] = useState<TaskRecordCollectionData | undefined>(undefined)
    const [lastTaskRecord, setLastTaskRecord] = useState<TaskRecord | undefined>(undefined)
    const [loading, setLoading] = useState<boolean>(false)
    const [numTaskRecInTRC, setNumTaskRecInTRC] = useState<number>(0);
    const [prevNumTaskRecInTRC, setNumPrevTaskRecInTRC] = useState<number>(0);
    const [returnInteracted, setReturnInteracted] = useState<boolean>(false);

    const [reachedReceipient, setReachedReceipient] = useState<boolean>(false)
    const [acknowledgeOpen, setAcknowledgeOpen] = useState<boolean>(false)

    const [robotReturned, setRobotReturned] = useState<boolean>(false);
    const [interacted, setInteracted] = useState<boolean>(false);
    const [openToClose, setOpenToClose] = useState<boolean>(false);
    const [disableCall, setDisableCall] = useState<boolean>(false);
    const [localState, setLocalState] = useState(0)
    const [selectedLocation, setSelectedLocation] = useState<string | undefined>("WARD 14F")


    // Error states
    const [robotError, setRobotError] = useState<boolean>(false)
    const [currentTaskRecordError, setCurrentTaskRecordError] = useState<boolean>(false)
    const [locationTaskRecordError, setLocationTaskRecordError] = useState<boolean>(false)
    const [globalTaskRecordError, setGlobalTaskRecordError] = useState<boolean>(false)

    // added for robot configurations
    const [robotConfig, setRobotConfig] = useState<{[id: number]: string | undefined}>({})

    useQuery(robotsList, async ()=> {
        listRobots().then(response => {
            // console.log(response.data)
            setRobotError(false)
            setRobotsList(response.data as unknown as RobotListData[]);
            let currSelectedRobot = selectedRobot as RobotDetailData;
            setSelectedRobot(response.data[0] as unknown as RobotDetailData); // autoselect the first robot
            if (selectedRobot){
                // console.log(currentLocationID + " vs " + currSelectedRobot.location.id)
                if (currentLocationID === currSelectedRobot.location.id && currentLocationID !== 14 // charge station
                    && !(currentTaskRecord?.status === TaskStatus.FAILED 
                        || currentTaskRecord?.status === TaskStatus.FAILED_LOCAL 
                        || currentTaskRecord?.status === TaskStatus.ERROR)
                    && !openToClose) {
                    setRobotReturned(true);
                }
            }
        }).catch(e => {
            setRobotError(true)
            setRobotsList([])
        });
    }, {
        refetchInterval: 1000,
    });

    useEffect(() => {
        setInteracted(false)
        setAcknowledgeOpen(false)
    }, [numTaskRecInTRC])

    useEffect(() => {
        if (!(currentTaskRecordCollection && latestGlobalTaskRecordCollection &&
            currentTaskRecordCollection.id === latestGlobalTaskRecordCollection.id &&
            currentTaskRecordCollection?.taskCollectionType !== TaskCollectionType.CHARGING_JOB &&
            (currentTaskRecordCollection?.status === TaskStatus.COMPLETED) && 
            currentTaskRecordCollection.progressIndex === 4)) {
            setReturnInteracted(false)
        }
    }, [currentTaskRecordCollection])

    // useQuery("taskRecordCollection", async()=> {
    //     try{
    //         const latestTaskCollector = await latestLocationTaskCollections(currentLocationID)
    //         setCurrentTaskRecordCollection(latestTaskCollector)
    //         setCurrentTaskRecordError(false)
    //         // console.log(latestTaskCollector)
    //         if(latestTaskCollector.taskRecords.length > 0) {
    //             const latestTaskRecord = await getTask(latestTaskCollector.taskRecords[latestTaskCollector.taskRecords.length - 1].taskRecord)
    //             // console.log(latestTaskRecord)
    //             setLastTaskRecord(latestTaskRecord.data as TaskRecord)
    //         }
    //         if(latestTaskCollector.taskCollectionType === TaskCollectionType.CHARGING_JOB) {
    //             // VES location is at charging job, allow them to start a delivery from charger
    //             setStatus(0)
    //         } else if(latestTaskCollector.status === TaskStatus.QUEUED) {
    //             setStatus(1)
    //         } else if(latestTaskCollector.status === TaskStatus.IN_PROGRESS || latestTaskCollector.status === TaskStatus.ARRIVED) {
    //             setStatus(2)
    //         } else {
    //             if (latestTaskCollector.status === TaskStatus.FAILED_LOCAL) {
    //                 // reached location to do resend
    //                 setStatus(0)
    //             } else if (latestTaskCollector.status === TaskStatus.FAILED) {
    //                 setStatus(2)
    //             } else {
    //                 setStatus(0)
    //             }
    //         }
    //     } catch(e) {
    //         console.log(e)
    //         setCurrentTaskRecordError(true)
    //     }
    // },
    // {
    //     refetchInterval: 1000
    // })

    useQuery("recipeintOfTaskCollection", async () => {
        try {
            const latestRecipientRecord = await receipientOfTaskCollection(currentLocationID)
            setRecipientOfTaskRecordCollection(latestRecipientRecord)
            setLocationTaskRecordError(false)

            if(latestRecipientRecord.taskRecords?.length > 0 &&
                (latestRecipientRecord.status === TaskStatus.ARRIVED || latestRecipientRecord.status === TaskStatus.IN_PROGRESS)) {
                const latestTaskRecord = (await getTask(latestRecipientRecord.taskRecords[latestRecipientRecord.taskRecords.length - 1].taskRecord)).data as TaskRecord
                
                if(latestTaskRecord.path[0].location.id === currentLocationID 
                    && (latestTaskRecord.status === TaskStatus.ARRIVED || latestTaskRecord.status === TaskStatus.COMPLETED)) {
                    setReachedReceipient(true)
                } else {
                    setReachedReceipient(false)
                }
            }
        } catch(e) {
            console.log(e)
            setLocationTaskRecordError(true)
        }
    }, {
        refetchInterval: 1000
    })

    useQuery("latestGlobalTaskCollector", async() => {
        try{
            const gltc = await globalLatestLocationTaskCollections()
            setGlobalTaskRecordError(false)
            setLatestGobalTaskRecordColleection(gltc)
            if ((numTaskRecInTRC !== gltc.taskRecords.length)) {
                setNumPrevTaskRecInTRC(numTaskRecInTRC)
                setNumTaskRecInTRC(gltc.taskRecords.length)
            }
        } catch(e) {
            setGlobalTaskRecordError(true)
            console.log(e)
        }
    },
    {
        refetchInterval: 1000
    })

    useEffect(() => {
        try {
            const robotIDs = robotsList.map(robotListData => robotListData.id);
            if(robotIDs.length === 0) return;
            // console.log(robotIDs.length)
            listRobotsInfos({robotIds: robotIDs}).then(response => {
                setRobotsDetail(response.data as unknown as RobotDetailData[]);
                console.log(response.data)
            });
        } catch (e) {
            console.log(e)
        }
    }, [robotsList])

    // useEffect(()=>{},[selectedRobot])

    const handleTaskRecordCreation = (taskRecord: TaskRecord) => {
        setCurrentTaskRecord(taskRecord);
        setDisableCall(true);
    }

    const handleTaskCompleted = () => {
        setCurrentTaskRecord(undefined);
    }

    const handleTaskCanceled = ()=> {
        setCurrentTaskRecord(undefined); // explicitly ignore it
    }

    const handleOnRobotCardSelected = (robotDetailData: RobotDetailData) => {
        setSelectedRobot(robotDetailData);
    }

    const handleChangeState = (stateId: number) => {
        setStatus(stateId)
    }

    const handleLocalStateSelection = (stateId: number) => {
        setLocalState(stateId)
    }

    const handleTaskRecordCollectionCreation = (trc: TaskRecordCollectionData) => {
        setCurrentTaskRecordCollection(trc)
    }

    const handleTaskCreationLoadingStart = () => {
        setLoading(true)
    }

    const handleTaskCreationLoadingEnd = () => {
        setLoading(false)
    }

    const handleLocationSelection = (location:string) => {
        setSelectedLocation(location)
    }

    // console.log("=====================================================================")
    // console.log(interacted)
    // console.log("currentTaskRecordCollection")
    // console.log(currentTaskRecordCollection)
    // console.log("latestGlobalTaskRecordCollection")
    // console.log(latestGlobalTaskRecordCollection)
    // console.log("recipientOfTaskRecordCollection")
    // console.log(recipientOfTaskRecordCollection)
    // console.log(currentTaskRecordCollection?.id === latestGlobalTaskRecordCollection?.id)
    // console.log(recipientOfTaskRecordCollection?.id === latestGlobalTaskRecordCollection?.id)
    // console.log(acknowledgeOpen)
    // console.log(reachedReceipient)
    // console.log(returnInteracted)

    const handleYes = async () => {
        setInteracted(true);
        const taskCollectionData = {
            "name": "Resend Task at " + currentTaskRecordCollection?.name,
            "status": TaskStatus.QUEUED,
            "taskRecords": [],
            "sourceLocation": currentTaskRecordCollection?.sourceLocation,
            "createdDatetime": new Date(),
            "targetLocation": currentTaskRecordCollection?.targetLocation,
            "taskCollectionType": TaskCollectionType.RESEND_JOB,
            "compartmentIndex": currentTaskRecordCollection?.compartmentIndex,
            "waitTime": currentTaskRecordCollection?.waitTime
        } as TaskRecordCollectionSendData;
        console.log(taskCollectionData)

        try{
            // TODO: precreate tasks and hard code here
            const result = await createTaskCollection(taskCollectionData);
            console.log(result)
            handleTaskRecordCollectionCreation(result.data as TaskRecordCollectionData)
            // console.log(result);
            // const startTaskResult = await startTask({
            //     task_id: result.data.id,
            //     robot: robotData.id,
            // });
            // // console.log(startTaskResult.data);
            // setSuccess(true);
            // handleTaskRecordCreation(startTaskResult.data); // has to have id here
        } catch(e) {
            console.log(e);
            alert("resend failed")
            // setFailed(true);
        }
    }

    const handleNo = () => {
        setInteracted(true);
    }

    return <>
    <Box sx={{
        backgroundColor: "#F9F9F9",
        height: "75%",
        width: "100%",
    }}>
        <Stack direction="row" sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <Box sx={{
                width: "330px",
                paddingRight: "32px",
                paddingLeft: "64px",
            }}>
                {
                robotsDetail?.map(robotDetail => (
                    <RobotCardRobotConfig robotDetail={robotDetail}
                    handleOnClick={handleOnRobotCardSelected}
                    selected={JSON.stringify(robotDetail) === JSON.stringify(selectedRobot)}
                    isCharging={robotDetail.charge_stage === ChargeStatus.CHARGINGUSEPILE
                        || robotDetail.charge_stage === ChargeStatus.CHARGEFULLUSEPILE}
                    newRobotConfig={robotConfig}
                    setRobotConfig={(conf: { [id: number]: undefined | string; }) => setRobotConfig(conf)}
                    selectedLocation={selectedLocation} taskRecordCollector={latestGlobalTaskRecordCollection} />))}
            </Box>
            <Box sx={{
                minWidth: "61.7%",
                maxWidth: "100%",
                paddingRight: "64px",
                paddingBottom: "16px",
                marginTop: "4px"
            }}> 
            {/* TODO: set current location details */}
            <Card sx={{
                width: "100%",
                minHeight: "100%",
                backgroundColor: "#FFFFF9",
                position: "relative",
                // borderRadius: "25px",
            }}>
                {loading && <Backdrop open={loading} sx={{
                    position: "absolute",
                    backgroundColor: "transparent",
                }}><CircularProgress /></Backdrop>}

                {/* Notifications */}
        {selectedRobot  &&<>
        {/* <Modal disableEnforceFocus open={successOpen && !canceledOpen}>
            <Notification robot={selectedRobot} handleLoadedItem={() => {
                handleTaskCompleted();
                setSuccessOpen(false);
            } } message={"Robot has arrived"} displayImg={""} subtitle={"Please attend to the robot"} showDismiss={false}/>
        </Modal>
        <Modal disableEnforceFocus open={canceledOpen}>
            <Notification robot={selectedRobot} handleLoadedItem={async () => {
                handleTaskCanceled()
                setCanceledOpen(false);
            } } message={"Wait time elapsed"} displayImg={""} subtitle={"Robot has been released to do its next task"} showDismiss={true}/>
        </Modal> */}
        {/* <PinCode/> */}
        {
            recipientOfTaskRecordCollection && latestGlobalTaskRecordCollection &&
            latestGlobalTaskRecordCollection.id === recipientOfTaskRecordCollection.id &&
            recipientOfTaskRecordCollection.taskCollectionType !== TaskCollectionType.CHARGING_JOB &&
            recipientOfTaskRecordCollection.status === TaskStatus.ARRIVED && 
            ((recipientOfTaskRecordCollection.progressIndex === 3 && recipientOfTaskRecordCollection.taskCollectionType === TaskCollectionType.STANDARD_JOB)
            ||(recipientOfTaskRecordCollection.progressIndex === 2 && recipientOfTaskRecordCollection.taskCollectionType === TaskCollectionType.RESEND_JOB)) &&
            
            <Modal disableEnforceFocus open={!acknowledgeOpen && reachedReceipient}>
                <NotificationPinCode 
                    robot={selectedRobot}
                    message={"Robot is here"} displayImg={""} subtitle={"To be received by " + currentLocationName}
                    handleLoadedItem={() => { setAcknowledgeOpen(true); } }
                    completedText={'Completed'}/>
            </Modal>
        }

        {
            recipientOfTaskRecordCollection && latestGlobalTaskRecordCollection &&
            latestGlobalTaskRecordCollection.id === recipientOfTaskRecordCollection.id &&
            recipientOfTaskRecordCollection.taskCollectionType !== TaskCollectionType.CHARGING_JOB &&
            (recipientOfTaskRecordCollection.status === TaskStatus.FAILED 
                || recipientOfTaskRecordCollection.status === TaskStatus.FAILED_LOCAL) &&
            
            <Modal disableEnforceFocus open={!interacted}>
                <Notification 
                                robot={selectedRobot}
                                message={"Robot not attended"} displayImg={""} subtitle={"Robot has been released to do its next task"} 
                                handleLoadedItem={() => {setInteracted(true)} } showDismiss={true} />
            </Modal>
        }

        {
            currentTaskRecordCollection && latestGlobalTaskRecordCollection &&
            latestGlobalTaskRecordCollection.id === currentTaskRecordCollection.id &&
            currentTaskRecordCollection.taskCollectionType !== TaskCollectionType.CHARGING_JOB &&
            (currentTaskRecordCollection.status === TaskStatus.FAILED_LOCAL) &&
            
            <Modal disableEnforceFocus open={!interacted}>
                <NotificationYesNo 
                                robot={selectedRobot}
                                message={"Robot has returned"} displayImg={""} subtitle={"Do you want to resend the items?"} 
                                handleNo={handleNo} handleYes={handleYes} showYesNo={true}/>
            </Modal>
        }
        { // only for L1Charge
            latestGlobalTaskRecordCollection && currentLocationID === 53 && currentLocationID === latestGlobalTaskRecordCollection.targetLocation &&
            latestGlobalTaskRecordCollection.taskCollectionType === TaskCollectionType.CHARGING_JOB &&
            (latestGlobalTaskRecordCollection.status === TaskStatus.COMPLETED) &&             
            <Modal disableEnforceFocus open={!interacted}>
                <Notification 
                                robot={selectedRobot}
                                message={"Robot has returned to charge"} displayImg={""} subtitle={"Robot is ready for the next task"} 
                                handleLoadedItem={() => {setInteracted(true)} } showDismiss={true} />
            </Modal>
        }
        { // only for L1Charge
            currentLocationID === 53 &&
            currentTaskRecordCollection && latestGlobalTaskRecordCollection &&
            currentTaskRecordCollection.id === latestGlobalTaskRecordCollection.id &&
            currentTaskRecordCollection?.taskCollectionType !== TaskCollectionType.CHARGING_JOB &&
            (currentTaskRecordCollection?.status === TaskStatus.COMPLETED) && 
            ((currentTaskRecordCollection.taskCollectionType === TaskCollectionType.STANDARD_JOB && currentTaskRecordCollection.progressIndex === 4)
            ||(currentTaskRecordCollection.taskCollectionType === TaskCollectionType.RESEND_JOB && currentTaskRecordCollection.progressIndex === 3)) &&
            
            <Modal disableEnforceFocus open={!returnInteracted && currentTaskRecordCollection.sourceLocation !== currentTaskRecordCollection.targetLocation}>
                <Notification 
                                robot={selectedRobot}
                                message={"Robot has completed delivery"} displayImg={""} subtitle={"Robot is returning to VES"} 
                                handleLoadedItem={() => {setReturnInteracted(true)} } showDismiss={true} audioName="./assets/sound/robot_has_completed_delivery.mp3"/>
            </Modal>
        }
        </>}
                {
                status === 0 ?
                // <CallJobUpdated 
                //     // currentMap={map.PHARMACY} 
                //     currentMap={map.CGHTestElevator} 
                //     currentLocation={currentLocationID} 
                //     currentLocationName={currentLocationName} 
                //     handleTaskRecordCreation={handleTaskRecordCreation}
                //     robotData={selectedRobot}
                //     shouldDisableCall={disableCall}/>
                // // : status === 1 ?
                // //     <QueuedDeliveryUpdated taskRecord={currentTaskRecord} 
                // //     handleCanceled={handleTaskCanceled}/>
                // : status === 1 ?
                // <CallJobUpdated 
                //     // currentMap={map.PHARMACY} 
                //     currentMap={map.CGHTestElevator} 
                //     currentLocation={currentLocationID} 
                //     currentLocationName={currentLocationName} 
                //     handleTaskRecordCreation={handleTaskRecordCreation}
                //     robotData={selectedRobot}
                //     shouldDisableCall={disableCall}/>
                // : status === 2 && taskRobot ? <ProgressDeliveryUpdated 
                //                     taskRecord={currentTaskRecord}
                //                     robot={taskRobot}
                //                     handleCanceled={handleTaskCanceled} />
                // : <CreateDelivery 
                // // currentMap={map.PHARMACY} 
                // currentMap={map.CGHTestElevator}
                // currentLocation={currentLocationID} 
                // currentLocationName={currentLocationName} 
                // handleTaskRecordCreation={handleTaskRecordCreation}
                // robotData={selectedRobot}/>}
                <CompartmentJob currentMap={map.CGHTestElevator}
                                currentLocation={currentLocationID}
                                currentLocationName={currentLocationName}
                                handleTaskRecordCreation={handleTaskRecordCreation}
                                robotData={selectedRobot}
                                shouldDisableCall={disableCall}
                                setConfig={setRobotConfig}
                                robotConf={robotConfig}
                                changeState={handleChangeState}
                                handleTaskRecordCollectionCreation={handleTaskRecordCollectionCreation}
                                changeLocalstate={handleLocalStateSelection}
                                handleLoadingStart={handleTaskCreationLoadingStart}
                                handleLoadingEnd={handleTaskCreationLoadingEnd} 
                                handleLocationSelection={handleLocationSelection}/> 
                
                : status === 1 ?
                <QueuedDeliverySimulation handleCanceled={() => {
                                        setStatus(0);
                                    } } changeState={(id) => setStatus(id)} taskRecord={undefined} />
                
                : status === 2 ?
                
                <ProgressDeliveryTimeoutIndicationSimulation
                                            robot={selectedRobot}
                                            handleCanceled={handleTaskCanceled}
                                            handleChangeState={handleChangeState} taskRecord={undefined} intialLocalState={0} />

                : <></>
                }
            </Card>
            </Box>
        </Stack>
        {robotError && (currentTaskRecordError || locationTaskRecordError || globalTaskRecordError)
            ? <Alert severity='error'> There is a problem getting current task info, please try again later</Alert> 
            : robotError ? <Alert severity='error'> Cannot get robot information, please try again later</Alert>
            : currentTaskRecordError ? <Alert severity='error'> There is a problem getting current task info, please try again later</Alert>
            : locationTaskRecordError ? <Alert severity='error'> There is a problem getting your task info, please try again later</Alert>
            : globalTaskRecordError ? <Alert severity='error'> There is a problem getting the latest task info, please try again later</Alert> : <></>}
    </Box>
    </>
}